module.exports = __webpack_public_path__ + "media/packs/images/state/small/pick-33b339702ecb794b0941b62550b22fe0.svg";